// @ vendors
import { APIGet } from 'utilities/APIRequestHelper'
// @ commons
import apiURLBuilder from 'core/apiURLBuilder'
// @ constants
import actionTypes from 'constants/actionTypes'


const setLiminAccountIsFetching = () => ({
    type: actionTypes.SET_LIMIT_ACCOUNT_REQUEST,
});

const setLiminAccountSuccess = response => ({
    type: actionTypes.SET_LIMIT_ACCOUNT_SUCCESS,
    payload: {
        response
    }
});

const setLiminAccountFailure = ({ hasLimit = false } = {}) => ({
    type: actionTypes.SET_LIMIT_ACCOUNT_FAILURE,
    payload: {
        hasLimit
    }
});

const getLimitAccount = () => (dispatch) => {
    dispatch(setLiminAccountIsFetching());

    return APIGet(dispatch, apiURLBuilder.getURL('accountLimit'))
        .then(response => {
            dispatch(setLiminAccountSuccess(response));
        })
        .catch(response => {
            const hasLimit = response.error.status === 409
            if (hasLimit) {
                dispatch(setLiminAccountFailure({ hasLimit }));
            } else {
                dispatch(setLiminAccountFailure());
            }
        });
};

module.exports = {
    getLimitAccount,
};
